module.exports = __webpack_public_path__ + "static/Race2-70fe021061b951fd731b93d22f115707.pdf";